<app-page-container class="dealers-billing-container" [layoutType]="LayoutType.IntegratedTab" [tabConfig]="tabConfig" [title]="title" >
</app-page-container>
